// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"33":"00bb5158","208":"9ee9ba54","253":"79166f5d","374":"2f96af2c","488":"996c6a8c","561":"5d3d520c","657":"459b1155","702":"1201f96c","784":"2d5846ce","815":"d286b40b","885":"3c760a5c","972":"45754df3"}[chunkId] + ".chunk.js";
};